module.exports = __webpack_public_path__ + "static/media/image-crop-22-mobile.291f1dfc.jpg";